import { createContext } from 'react';

import { DEFAULT_CONTEXT_VALUES } from './constants';

const WorkoutContext = createContext(DEFAULT_CONTEXT_VALUES);

export default WorkoutContext;
